import { Link } from "react-router-dom";
import { EyeOff } from "lucide-react";
import { useShopSettings, isSectionOff } from "../lib/shopSettings";
import { useLang } from "../i18n/LanguageContext";

// Porte de visibilité : masque une page publique quand l'admin l'a désactivée
// (Paramètres → Pages et sections). Affiche un avis courtois à la place.
export default function PageGate({ pageKey, children }) {
  const settings = useShopSettings();
  const { lang } = useLang();
  if (!isSectionOff(settings, pageKey)) return children;
  return (
    <div data-testid={`page-off-${pageKey}`} className="min-h-[60vh] flex flex-col items-center justify-center px-6 pt-24 pb-16 text-center">
      <EyeOff className="w-10 h-10 text-gold/60 mb-6" />
      <h1 className="font-serif text-4xl mb-4">
        {lang === "fr" ? "Section temporairement hors ligne" : "Section temporarily offline"}
      </h1>
      <p className="text-ivory/60 max-w-md mb-8">
        {lang === "fr"
          ? "Cette section du site est désactivée pour le moment. Revenez bientôt ou écrivez-nous — nous répondons même en dehors des heures d'ouverture."
          : "This section of the site is currently disabled. Come back soon or write to us — we answer even outside business hours."}
      </p>
      <Link to="/" className="inline-flex items-center gap-3 bg-gold text-ink font-semibold px-8 py-4 rounded-full hover:bg-champagne transition-colors duration-300">
        {lang === "fr" ? "Retour à l'accueil" : "Back to home"}
      </Link>
    </div>
  );
}
